import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import Props, { MODE } from '@/components/app/archive/components/separator/type';

export default function Separator({ mode = MODE.HORIZONTAL, className }: Props) {
  return (
    <Container
      className={cn(
        'bg-[#F4F5F6]',
        mode === MODE.VERTICAL && 'w-[1px]',
        mode === MODE.HORIZONTAL && 'h-[1px] w-full',
        className,
      )}
    />
  );
}
